import "../scss/style.scss";
import 'nouislider/dist/nouislider.css';
import 'plyr/src/sass/plyr.scss';

import Plyr from 'plyr'

import Lenis from '@studio-freight/lenis'
import gsap from "gsap";
import { CustomEase } from "gsap/CustomEase.js";
import {Howl, Howler} from 'howler';
import noUiSlider from 'nouislider';
import tinycolor from "tinycolor2";

gsap.registerPlugin(CustomEase);
CustomEase.create("cubic-1", ".25,.1,.25,1");

import AwdSVG from '../images/awd.svg';
import LogoSVG from '../images/logo.svg';
import PlaySVG from '../images/play.svg';
import PauseSVG from '../images/pause.svg';
import StopSVG from '../images/stop.svg';
import VolumeSVG from '../images/volume.svg';

let winsize = {width: window.innerWidth, height: window.innerHeight};

function calcWinsize(){
	return {width:window.innerWidth, height:window.innerHeight}
}

const _isTablet = () => {
	let ratio = window.devicePixelRatio || 1;
	let screen = {
			width : window.screen.width * ratio,
			height : window.screen.height * ratio
	};
	if(
		(screen.width === 2048 && winsize.width === 1024) || //iPad Pro Portrait (sia realtà sia ispezionatore)
		(screen.width === 1536 && screen.height === 2048)  //Forse iPad reale Portrait e Landscape e iPad ispezionatore portrait
	){
		return true;
	}
	else {
		return false;
	}
}
export let isTablet = _isTablet();

const _isMobile =  () => {
	if(winsize.width <= 1023){
		return true;
	}
	else{
		return false;
	}
}
export let isMobile = _isMobile();

//Anche iPad Pro Landscape
const _isAllTablet = () => {
	let response;
    let ratio = window.devicePixelRatio || 1;
    let screen = {
			width : window.screen.width * ratio,
			height : window.screen.height * ratio
    };
		//alert('Screen' + screen.width+ ' | w' + winsize.width);

    //!DECOMMENTARE IN PRODUZIONE, COMMENTARE QUELLO SOTTO
    //!iPad Pro: nella realtà window.screen.width è SEMPRE == a 1024, anche quando è LANDSCAPE, quindi QUESTO if è quello corretto
    if(
    	(screen.width === 2048 && winsize.width === 1024) || //iPad Pro Portrait //*iPad Portrait nella realtà
    	(screen.width === 1640 && winsize.width === 820) || //iPad Air Portrait //*iPad Portrait nella realtà
    	(screen.width === 1668 && winsize.width === 834) || //iPad Pro 11 //*iPad Portrait nella realtà
        //Se screen.height stampa 2732,questo if varrebbe per iPad pro landscape reale
    	(screen.width === 2048 && screen.height === 2732) || //!ispezionatore iPad Pro Portrait (serve solo quando si debugga col simulatore di Chrome)
    	(screen.width === 2048 && winsize.width === 1366) || //iPad Pro Landscape //*iPad Landscape nella realtà
    	(screen.width === 1640 && winsize.width === 1180) || //Pad Air Landscape //*iPad Landscape nella realtà
    	(screen.width === 1668 && winsize.width === 1194) || //iPad Pro 11 //*iPad Landscape nella realtà
    	(screen.width === 2732 && screen.height === 2048) || //!ispezionatore iPad Pro Landscape (serve solo quando si debugga col simulatore di Chrome)
    	(screen.width === 1536 && screen.height === 2048) || //iPad
    	(screen.width === 2048 && screen.height === 1536)){
    	response = true;
    }
    else {
    	response = false;
    }

    return response;
}

export let isAllTablet = _isAllTablet();

const _isAllMobileDevices =  () => {
	if(winsize.width <= 1023 || isAllTablet){
		return true;
	}
	else{
		return false;
	}
}
export let isAllMobileDevices = _isAllMobileDevices();

window.addEventListener('resize', () => {
	winsize = calcWinsize();
	isAllMobileDevices = _isAllMobileDevices();
	isMobile = _isMobile();
	isTablet = _isTablet();
	isAllTablet = _isAllTablet()
});

export const customScrollPage = () => {
	const customScroll = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		orientation: 'vertical', // vertical, horizontal
		gestureOrientation: 'vertical', // vertical, horizontal, both
		smoothWheel: true,
		wheelMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 30,
		infinite: false,
	})

	function raf(time) {
		customScroll.raf(time)
		requestAnimationFrame(raf)
	}
	requestAnimationFrame(raf)

	/* setTimeout(() => {
		customScroll.scrollTo(0, {
			immediate: true,
			force: true,
			lock: true,
			onComplete: () => console.log('dd')
		})
	}, 500) */;
	
	return customScroll
}

export const HeaderFunction = () => {
	document.querySelector('header .logo').innerHTML = LogoSVG
	document.querySelector('footer .bottom .right .credits a').innerHTML = AwdSVG
}

export const ScrollBarCustom = (scroll) => {
	const createScrollbar = () => {
		let scrollbar = document.createElement('div');
		let innerScrollbar = document.createElement('div');
		scrollbar.setAttribute('id', 'custom-scrollbar');
		innerScrollbar.classList.add('inner-scrollbar');

		scrollbar.appendChild(innerScrollbar);
		document.getElementById('container').appendChild(scrollbar)
		//this.scrollbar = document.getElementById('custom-scrollbar')
	}

	const setScrollbarDimensions = () => {
		//let winH = scroll.dimensions.height;
		let winH = window.innerHeight;
		//let fullH = scroll.dimensions.scrollHeight;
		let fullH = document.getElementById('container').getBoundingClientRect().height;
		let perc = (winH*100)/fullH;
		let scrollbar = document.getElementById('custom-scrollbar');
		let inner = scrollbar.querySelector('.inner-scrollbar');
		inner.style.height = `${perc}%`;

		return (100 - perc);
	}

	const animateScrollbar = (scrollbarProgress) => {
		let perc = setScrollbarDimensions()
		//progress va da 0 a 1
		//console.log(scrollbarProgress)
		let percH = scrollbarProgress*perc;
		let scrollbar = document.getElementById('custom-scrollbar');
		let inner = scrollbar.querySelector('.inner-scrollbar');
		inner.style.top = `${percH}%`
	}

	
	createScrollbar()
	setScrollbarDimensions()
	setTimeout(() => {
		setScrollbarDimensions()
	}, 1500)
	window.addEventListener('resize', () => setScrollbarDimensions())

	scroll.on('scroll', (e) => {
		let scrollbarProgress = e.progress
		animateScrollbar(scrollbarProgress)
	})
}

export class mousePointer {
	constructor(){
		this.w = window.innerWidth;
		this.h = window.innerHeight;
		this.cursor = document.getElementById('cursor')
		this.mousePosition = {
			x: this.w/2,
			y: this.h/2
		};
		this.init();
	}
	init(){
		this.setMousePositon()
		//this.updateCursorClass()
		window.addEventListener("mousemove", (e) => this.mouseMove(e));
	}
	setMousePositon(){
		gsap.to(this.cursor, { duration: 0.1, top: this.mousePosition.y, left: this.mousePosition.x, ease: 'cubic-1' })
	}
	mouseMove(event){
		this.mousePosition.x = event.clientX
		this.mousePosition.y = event.clientY
		this.setMousePositon()
	}
	static updateCursorClass() {
		let c1 = document.getElementById('cursor')

		let class1 = document.querySelectorAll('.custom-cursor-hover');
		[...class1].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('hover'); });
			el.addEventListener('mouseleave', () => { c1.classList.remove('hover'); mousePointer.cleanCursorClass(); });
		});

		let class2 = document.querySelectorAll('.custom-cursor-listen');
		[...class2].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('listen'); });
			el.addEventListener('mouseleave', () => { c1.classList.remove('listen'); mousePointer.cleanCursorClass(); });
		});

		let class3 = document.querySelectorAll('.custom-cursor-play');
		[...class3].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('play'); });
			el.addEventListener('mouseleave', () => { /* c1.classList.remove('play'); */ mousePointer.cleanCursorClass(); });
		});

		let class4 = document.querySelectorAll('.custom-cursor-pause');
		[...class4].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('pause');  });
			el.addEventListener('mouseleave', () => { /* c1.classList.remove('pause'); */ mousePointer.cleanCursorClass(); });
		});

		let class5 = document.querySelectorAll('.custom-cursor-stop');
		[...class5].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('stop'); });
			el.addEventListener('mouseleave', () => { c1.classList.remove('stop'); mousePointer.cleanCursorClass(); });
		});

		let class6 = document.querySelectorAll('.custom-cursor-playpause');
		[...class6].forEach((el) => {
			el.addEventListener('mouseenter', () => { 
				if(el.classList.contains('play')){
					c1.classList.add('play');
				}else{
					c1.classList.add('pause');
				}
				
			 });
			el.addEventListener('mouseleave', () => { mousePointer.cleanCursorClass(); });
		});

		let class7 = document.querySelectorAll('.custom-cursor-video');
		[...class7].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('videoplay'); });
			el.addEventListener('mouseleave', () => { mousePointer.cleanCursorClass(); });
		});
	}
	static cleanCursorClass() {
		let c1 = document.getElementById('cursor')

		c1.removeAttribute('class');
		c1.classList.add('cursor');
	}
}

export class Home {
	constructor() {
		this.blocks = document.querySelectorAll('.podcast--blocks .podcast');
		this.videos = document.querySelectorAll('.podcast--blocks .video');
		this.audioPlayer = document.getElementById('audioPlayer');
		this.volumeBar = this.audioPlayer.querySelector('.volume .bar');
		this.videoBar = this.audioPlayer.querySelector('.timebar .bar');
		this.playPause = this.audioPlayer.querySelector('.playpause');
		this.stop = this.audioPlayer.querySelector('.stop');

		this.videoPlayer = document.getElementById('videoPlayer');

		this.volSlide;
		this.videoSlide;
		this.currentSound;
		this.newSound;
		this.sounds = [];

		this.videoPlay

		this.isPlayerOpen = false;
		this.init()
	}
	init() {

		document.querySelectorAll('.mobile-play-icon').forEach((play) => {
			play.innerHTML = PlaySVG;
			play.querySelector('svg').style.fill = play.dataset.color
		})

		mousePointer.updateCursorClass();
		let that = this;
		this.setSoundbarIcons();
		this.setSliders();
		[...this.blocks].forEach((block) => {
			let json = JSON.parse(block.querySelector('.podcast-json').value)
			let file = block.querySelector('.podcast-file').value;
			let color = block.dataset.color

			block.dataset.sound = this.sounds.length

			let howl = new Howl({
				src: [file],
				preload: true,
				html5: false,
				volume: 0.5,
				onplay: function() {
					
					that.playPause.classList.add('play')
					that.playPause.classList.remove('pause')

					that.setDuration(howl.duration())

					let updatedRaf = undefined;

					const onAnimationFrame = () => {
						if (howl.playing()) {
							let seek = howl.seek()
							const width = (howl.seek() / howl.duration()) * 100;

							that.videoSlide.set(width)

							that.audioPlayer.querySelector('.timebar .timer').innerHTML = that.formatTime(Math.round(seek));
							that.audioPlayer.querySelector('.mobile-timebar .mobile-timer').innerHTML = that.formatTime(Math.round(seek));

							updatedRaf = requestAnimationFrame(onAnimationFrame);
						}else {
							if (updatedRaf) {
								cancelAnimationFrame(updatedRaf);
							}
						}
					};
					updatedRaf = requestAnimationFrame(onAnimationFrame);
        },
				onpause: function() {
					that.playPause.classList.remove('play')
					that.playPause.classList.add('pause')
				},
				onend: function() {
					howl.stop()
					that.closeSoundBar()
				},
				onstop: function() {
					that.videoSlide.set(0)
				},
        onseek: function() {
					that.audioPlayer.querySelector('.timebar .timer').innerHTML = that.formatTime(Math.round(howl.seek()));
					that.audioPlayer.querySelector('.mobile-timebar .mobile-timer').innerHTML = that.formatTime(Math.round(howl.seek()));

          let updatedRaf = undefined;

					const onAnimationFrame = () => {
						if (howl.playing()) {
							let seek = howl.seek()
							const width = (howl.seek() / howl.duration()) * 100;

							that.videoSlide.set(width)

							that.audioPlayer.querySelector('.timebar .timer').innerHTML = that.formatTime(Math.round(seek));
							that.audioPlayer.querySelector('.mobile-timebar .mobile-timer').innerHTML = that.formatTime(Math.round(seek));

							updatedRaf = requestAnimationFrame(onAnimationFrame);
						}else {
							if (updatedRaf) {
								cancelAnimationFrame(updatedRaf);
							}
						}
					};
					updatedRaf = requestAnimationFrame(onAnimationFrame);
        }
			});

			let data = { howl, json, color };

			this.sounds.push(data);
		});

		[...this.blocks].forEach((block) => {
			block.addEventListener('click', () => {
				this.newSound = block.dataset.sound

				this.animateSoundBar(block.dataset.sound).then(() => {
					this.currentSound = block.dataset.sound;

					this.sounds.forEach((sn) => {
						sn.howl.stop()
					})

					let snd = this.sounds[this.currentSound].howl;

					let id = snd.play()
				});
			})
		});

		this.playPause.addEventListener('click', () => {
			let snd = this.sounds[this.currentSound].howl;
			if(this.playPause.classList.contains('play')){

				//mousePointer.cleanCursorClass();
				document.getElementById('cursor').classList.add('pause')
				document.getElementById('cursor').classList.remove('play')
				/* this.playPause.classList.add('custom-cursor-pause')
				this.playPause.classList.remove('custom-cursor-play')
				mousePointer.updateCursorClass(); */

				snd.pause()
			}else{
				//mousePointer.cleanCursorClass();
				document.getElementById('cursor').classList.remove('pause')
				document.getElementById('cursor').classList.add('play')
				/* this.playPause.classList.add('custom-cursor-play')
				this.playPause.classList.remove('custom-cursor-pause')
				mousePointer.updateCursorClass(); */

				snd.play()
			}
		})
		this.stop.addEventListener('click', () => {
			let snd = this.sounds[this.currentSound].howl;
			snd.stop()
			this.closeSoundBar()
		})

		this.videos.forEach((video) => {
			video.addEventListener('click', () => {
				let file = video.querySelector('.video-file').value;

				let color = video.dataset.color
				this.videoPlayer.querySelector('video').setAttribute('src', file)
				let color2;

				let clr = tinycolor(color);
				if(clr.isDark()){
					this.audioPlayer.classList.add('dark')
					this.audioPlayer.classList.remove('light')
					color2 = clr.lighten(10).toString();
				}else{
					this.audioPlayer.classList.add('light')
					this.audioPlayer.classList.remove('dark')
					color2 = clr.lighten(5).toString();
				}

				gsap.to(this.videoPlayer.querySelector('.closeVideoPlayer'), { duration: 1, backgroundColor: color2 })

				this.videoPlayer.setAttribute('style', '--player-color: ' + color + ';')

				this.videoPlay = new Plyr(this.videoPlayer.querySelector('video'), {
					hideControls: true,
					controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'airplay', 'fullscreen']
				});

				this.animateVideoBar().then(() => {
					this.videoPlay.play()
				})

				this.videoPlay.on('ready', () => {
					this.videoPlayer.setAttribute('style', '--plyr-color-main: ' + color + ';')
				});

			})
		})

		this.videoPlayer.querySelector('.closeVideoPlayer').addEventListener('click', () => {
			this.videoPlay.stop()
			this.closeVideoBarFunction().then(() => {
				this.videoPlay.destroy()
			})
		})
	}
	
	getStep(sound) {
		var seek = sound.seek() || 0;
		// console.log("🚀 ~ file: functions.js:227 ~ Home ~ getStep ~ seek:", seek)
		this.audioPlayer.querySelector('.timebar .timer').innerHTML = this.formatTime(Math.round(seek));
    //console.log(self.formatTime(Math.round(seek)))

    // If the sound is still playing, continue stepping.
    if (sound.playing()) {
      requestAnimationFrame(this.getStep(sound));
    }
	}
	setSliders() {
		this.volSlide = noUiSlider.create(this.volumeBar, {
			start: 50,
			connect: [true, false],
			animate: true,
			animationDuration: 300,
			range: {
				'min': 0,
				'max': 100
			}
		});
		this.volSlide.on('slide', (e) => {
			Howler.volume((e[0]/100));
		})
		this.videoSlide = noUiSlider.create(this.videoBar, {
			start: 0,
			connect: [true, false],
			animate: true,
			animationDuration: 300,
			range: {
				'min': 0,
				'max': 100
			}
		});
		this.videoSlide.on('slide', (e) => {
			let sound = this.sounds[this.currentSound].howl;
			//console.log(sound.seek())
			sound.seek(sound.duration() * (e[0]/100))
			//console.log(, e[0])
		})
	}
	setDuration(sec){
		this.audioPlayer.querySelector('.timebar .duration').innerHTML = this.formatTime(sec)
		this.audioPlayer.querySelector('.mobile-timebar .mobile-duration').innerHTML = this.formatTime(sec)
	}
	setSoundbarIcons() {
		this.audioPlayer.querySelector('.playpause .play').innerHTML = PlaySVG
		this.audioPlayer.querySelector('.playpause .pause').innerHTML = PauseSVG
		this.audioPlayer.querySelector('.stop').innerHTML = StopSVG
		this.audioPlayer.querySelector('.volume .icon').innerHTML = VolumeSVG
	}
	closeSoundBar() {
		this.isPlayerOpen = false;
		gsap.to(this.audioPlayer, { duration: 1, bottom: 0, y: '100%', ease: 'cubic-1' })
	}
	animateSoundBar(order) {
		let json = this.sounds[order].json;
		return new Promise((resolve, reject) => {
			
			if(this.isPlayerOpen){
				let sound = this.sounds[this.currentSound].howl;
				sound.stop()
				this.audioPlayer.querySelector('.preview .image .inner img').setAttribute('src', json.image);
				this.audioPlayer.querySelector('.preview .text h3').innerHTML = json.titolo
				if(json.sottotitolo != ''){
					this.audioPlayer.querySelector('.preview .text h4').innerHTML = json.sottotitolo
				}else{
					this.audioPlayer.querySelector('.preview .text h4').innerHTML = ''
				}

				let color = tinycolor(this.sounds[this.newSound].color);
				let color2;
				if(color.isDark()){
					this.audioPlayer.classList.add('dark')
					this.audioPlayer.classList.remove('light')
					color2 = color.lighten(10).toString();
				}else{
					this.audioPlayer.classList.add('light')
					this.audioPlayer.classList.remove('dark')
					color2 = color.lighten(5).toString();
				}
				gsap.to(this.playPause, { duration: 1, backgroundColor: color2 })
				gsap.to(this.stop, { duration: 1, backgroundColor: color2 })
				gsap.to(this.audioPlayer, { duration: 1, backgroundColor: this.sounds[this.newSound].color, ease: 'cubic-1', onComplete: () => resolve() })
			}else{
				this.isPlayerOpen = true;
				
				let color = tinycolor(this.sounds[order].color);
				let color2;
				if(color.isDark()){
					this.audioPlayer.classList.add('dark')
					color2 = color.lighten(10).toString();
				}else{
					this.audioPlayer.classList.add('light')
					color2 = color.lighten(5).toString();
				}

				gsap.to(this.audioPlayer, { duration: 0, backgroundColor: this.sounds[order].color })
				gsap.to(this.playPause, { duration: 0, backgroundColor: color2 })
				gsap.to(this.stop, { duration: 0, backgroundColor: color2 })

				this.audioPlayer.querySelector('.preview .image .inner img').setAttribute('src', json.image);
				this.audioPlayer.querySelector('.preview .text h3').innerHTML = json.titolo
				if(json.sottotitolo != ''){
					this.audioPlayer.querySelector('.preview .text h4').innerHTML = json.sottotitolo
				}else{
					this.audioPlayer.querySelector('.preview .text h4').innerHTML = ''
				}

				//gsap.to(document.getElementById('container'), { duration: 1, paddingBottom: '10rem', ease: 'cubic-1'  })
				gsap.to(this.audioPlayer, { duration: 1, bottom: '6rem', y: 0, ease: 'cubic-1', onComplete: () => resolve() })
			}
		});
	}
	animateVideoBar() {
		return new Promise((resolve, reject) => {
			gsap.to(this.videoPlayer, { duration: 1, bottom: '5rem', y: 0, ease: 'cubic-1', onComplete: () => resolve() })
		})
	}
	closeVideoBarFunction() {
		return new Promise((resolve, reject) => {
			gsap.to(this.videoPlayer, { duration: 1, bottom: 0, y: '100%', ease: 'cubic-1', onComplete: () => resolve() })
		})
	}
	formatTime(secs) {
    var minutes = Math.floor(secs / 60) || 0;
    var seconds = (secs - minutes * 60) || 0;

    return minutes + ':' + (Math.round(seconds) < 10 ? '0' : '') + Math.round(seconds);
  }
}